export default {
  pageTitle: {
    id: 'dashboard_my_favorites_title',
    defaultMessage: 'My Favorites',
  },
  itemsCount: {
    id: 'dashboard_my_favorites_items_count',
    defaultMessage: `{count, plural,
          one {# item}
          other {# items}
        }`,
  },
  bannerTitle: {
    id: 'favorites_app_download_banner_title',
    defaultMessage: 'Save on your faves',
  },
  bannerDescription: {
    id: 'favorites_app_download_banner_description',
    defaultMessage:
      'Find out when prices drop on your favorites by downloading the app.',
  },
}
